import priceTagLayouts from '@enums/price-tag-layouts';

export const DEFAULT_PRICE_TAG = Object.freeze({ layout: priceTagLayouts.fallback, fields: [] });

const knownLayouts = new Set(Object.values(priceTagLayouts));

export const resolvePriceTagPreset = ({
    priceTag,
    offerMechanic,
    priceTagsKeyed,
    priceTagIdsByOfferTemplate,
    defaultPresetId,
}) => {
    const mechanicPresetId = offerMechanic?.uiFields?.offerTemplate;
    const linkedPriceTagId = priceTag?.priceTagId || priceTagIdsByOfferTemplate?.[mechanicPresetId];
    const resolvedPriceTagId =
        (linkedPriceTagId && priceTagsKeyed[linkedPriceTagId] && linkedPriceTagId) ||
        (defaultPresetId && priceTagsKeyed[defaultPresetId] && defaultPresetId);
    return resolvedPriceTagId
        ? { priceTagId: resolvedPriceTagId, priceTag: priceTagsKeyed[resolvedPriceTagId] }
        : { priceTagId: defaultPresetId, priceTag: DEFAULT_PRICE_TAG };
};

export const resolvePriceTagLayout = layout =>
    knownLayouts.has(layout) ? layout : priceTagLayouts.fallback;

export default { DEFAULT_PRICE_TAG, resolvePriceTagLayout, resolvePriceTagPreset };
